import React, {Component} from 'react';
import { BrowserRouter as Router, Route, Link, withRouter,Switch } from "react-router-dom";
import UserSetup from './UserSetup';
import VenueSetup from './VenueSetup';
import UserManagement from './UserManagement';
import AddLostItem from './AddLostItem';
import AddLostItemWeb from './AddLostItemWeb';
import CreateLabel from './CreateLabel';
import PrintingLabels from './PrintingLabels';
import Refunds from './Refunds';
import LostAndFound from './LostAndFound';
import ClaimsDoc from './Claims';
import WhenAGuestCalls from './WhenAGuestCalls';
import AddingUsers from './AddingUsers';
import InstallMobileApp from './InstallMobileApp';
import HowItWorks from './HowItWorks';
import ShipCentral from './ShipCentral';
import ComingSoon from './ComingSoon';
import BasicsVideo from './BasicsVideo';
import LMSTraining from './LMSTraining';
import loggingItems from './Videos/loggingItems';
import searchingItems from './Videos/searchingItems';
import reportingItems from './Videos/reporting';
import shippingItems from './Videos/shippingItems';

class MainDoc extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
        checkingSession: false
      };
    }
    render() {

      return (
        <div className="wrapper">
       
       
          
          <Router>
  
               <div className='container-fluid' style={{ margin: 0, }}>
                 
                      <div className="row">
                          <div className='col-2' >
                              <nav id="sidebar" >
                              <h5>Video Training</h5>
                              <ul className="list-group">

                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                      <Link to="/loggingItems" >Logging Items</Link>
                                  </li>
                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                      <Link to="/searchingItems" >Searching Items</Link>
                                  </li>

                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                      <Link to="/reportingItems" >Reporting Items</Link>
                                  </li>
                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                      <Link to="/shippingItems" >Shipping Items</Link>
                                  </li>
                              
  
                              </ul>
                              <br/>

                              <h5>Getting Started</h5>
                              <ul className="list-group">

                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                      <Link to="/InstallMobileApp" >Install The Mobile App</Link>
                                  </li>

                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                  
                                  <Link to="/UserSetup" >User Setup</Link>
                                  </li>

                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                  <Link to="/AddingUsers" >Adding Users (Admin)</Link>
                                  </li>
                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                      <Link to="/VenueSetup" >Venue Settings (Admin)</Link>
                                  </li>
                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                      <Link to="/UserManagement" >Update User Settings</Link>
                                  </li>
                               
                                 
                              
                              
  
                              </ul>
                              <br/>
                              <h5>Basics</h5>
                              <ul className="list-group">
                              
                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                  <Link to="/HowItWorks" >How It All Works</Link>
                                  </li>

                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                  <Link to="/AddLostItem" >Add a Lost Item: Mobile</Link>
                                  </li>
                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                  <Link to="/AddLostItemWeb" >Add a Lost Item: Web</Link>
                                  </li>
                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                  <Link to="/LostAndFound" >Lost &amp; Found</Link>
                                  </li>
                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                  <Link to="/ClaimsDoc" >Claims</Link>
                                  </li>
                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                  <Link to="/WhenAGuestCalls" >When a Guest Calls</Link>
                                  </li>
                              
  
                              </ul>
                              <br/>
                              <h5>Shipping</h5>
                              <ul className="list-group">
                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                  <Link to="/CreateLabel" >Create a Label</Link>
                                  </li>
                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                      <Link to="/PrintingLabels" >Printing Labels</Link>
                                  </li>
                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                      <Link to="/Refunds">Refunds</Link>
                                  </li>
                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                      <Link to="/ShipCentral">Ship Central</Link>
                                  </li>
                              
                              
  
                              </ul>
                              <br/>
                              <h5>Reports</h5>
                              <ul className="list-group">
                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                  <Link to="/ComingSoon" >Inventory Management</Link>
                                  </li>
                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                      <Link to="/ComingSoon" >Claims Reports</Link>
                                  </li>
                                  <li className="nav-item d-flex justify-content-between align-items-center">
                                      <Link to="/ComingSoon" >Shipping Reporting</Link>
                                  </li>
  
                              
                              
  
                              </ul>

                          </nav>
                          </div>
                      
  
  
                      <div className='col-10'>
                          <div style={{ flex: 1, padding: "5px" }}>
                          <Switch>
                              <Route exact path='/AddingUsers' component={AddingUsers}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/VenueSetup' component={VenueSetup}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/UserManagement' component={UserManagement}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/AddLostItem' component={AddLostItem}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/AddLostItemWeb' component={AddLostItemWeb}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/CreateLabel' component={CreateLabel}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/PrintingLabels' component={PrintingLabels}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/Refunds' component={Refunds}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/LostAndFound' component={LostAndFound}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/ClaimsDoc' component={ClaimsDoc}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/WhenAGuestCalls' component={WhenAGuestCalls}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/UserSetup' component={UserSetup}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/InstallMobileApp' component={InstallMobileApp}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/HowItWorks' component={HowItWorks}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/ShipCentral' component={ShipCentral}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/ComingSoon' component={ComingSoon}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/BasicsVideo' component={BasicsVideo}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/LMSTraining' component={LMSTraining}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/loggingItems' component={loggingItems}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/searchingItems' component={searchingItems}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/reportingItems' component={reportingItems}  checkingSession={this.state.checkingSession}/>
                              <Route exact path='/shippingItems' component={shippingItems}  checkingSession={this.state.checkingSession}/>

                             </Switch>
  
                          </div>
  
                      </div>
                  </div>    
                  
     
                  </div> 
  
  
      </Router>

      </div>




      )
    }
  }
  


  export default withRouter(MainDoc);


